import axios from 'axios'
import store from "../store";

const api = axios.create({
    baseURL: '/api',
})

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
if (csrfToken) {
    api.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken
}

api.interceptors.request.use(
    config => {
        const token = localStorage.getItem("access_token");
        if (token) {
            config.headers.common["Authorization"] = `Bearer ${token}`;
        }
        store.commit("increaseLoader");
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    response => {
        store.commit("decreaseLoader");
        if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        store.commit("decreaseLoader");
        if (error.response.status) {
            switch (error.response.status) {
                case 401:
                case 403:
                    sessionStorage.clear();
                    localStorage.clear();
                    delete axios.defaults.headers.common['Authorization'];
                    window.location.reload();
                    break;
            }
        }
        return Promise.reject(error);
    }
);

export default api;
